var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-line-icons:docs",
    clipPath: "url(#clip0_859_4030)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.738 0.768764H9.36106C8.62036 0.768764 8.01981 1.36931 8.01981 2.11002H15.3967V7.47506H20.7618V18.2051H16.0674V19.5464H20.7618C21.5025 19.5464 22.103 18.9458 22.103 18.2051V6.13413L16.738 0.768764ZM16.738 6.1338V2.6653L20.2058 6.1338H16.738ZM1.98414 3.45128C1.24343 3.45128 0.642883 4.05183 0.642883 4.79254V20.8876C0.642883 21.6284 1.24343 22.2289 1.98414 22.2289H13.3848C14.1256 22.2289 14.7261 21.6284 14.7261 20.8876V8.81665L9.36106 3.45128H1.98414ZM13.3848 20.8876H1.98414V4.79254H8.01981V10.1576H13.3848V20.8876ZM9.36106 8.81632V5.34782L12.8289 8.81632H9.36106Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_4030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4601,
    height: 21.4601,
    fill: "white",
    transform: "translate(0.642883 0.768764)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsReporting);
export default __webpack_public_path__ + "static/media/settings-reporting.b32af9a14244f92f643fa3aa585de88f.svg";
export { ForwardRef as ReactComponent };